import { fetchAuthToken } from "app/Auth";
import Constants from "common/constant";

export const createChatMessage = async ({ message }: { message: string }) => {
  const token = await fetchAuthToken();
  return fetch(`${Constants.apiHost}/v1/assistant/chat/contact`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({ message }),
  });
};

export const createThreadMessage = async ({
  thread_id,
  message,
}: {
  thread_id: string;
  message: string;
}) => {
  const token = await fetchAuthToken();
  return fetch(`${Constants.apiHost}/v1/assistant/thread/${thread_id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({ message }),
  });
};
